import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Route } from '../../../utils/route';
import { DictionaryService } from '../../../services/dictionary.service';
import { ReportsService } from '../../../services/reports.service';
import { ConfigService } from '../../../services/config.service';
import { reportResponse } from '../../../interfaces/apis/reports';
import { TabsComponent } from '../../../components/tabs/tabs.component';
import { ButtonDirective } from '../../../components/button/button.directive';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  iconoirMultiBubble,
  iconoirOpenInWindow,
  iconoirHealthShield,
  iconoirNavArrowLeft,
} from '@ng-icons/iconoir';
import { VersionsCallsChartsTabComponent } from './versions-calls-charts-tab/versions-calls-charts-tab.component';
import { RepsCallsChartsTabComponent } from './reps-calls-charts-tab/reps-calls-charts-tab.component';
import { CallsDurationsTabComponent } from './calls-durations-tab/calls-durations-tab.component';
import { state } from '@angular/animations';

type ReportType = 'comments' | 'sfe';

@Component({
  selector: 'app-product-details',
  imports: [
    TabsComponent,
    NgIcon,
    VersionsCallsChartsTabComponent,
    RepsCallsChartsTabComponent,
    CallsDurationsTabComponent,
  ],
  providers: [
    provideIcons({
      iconoirMultiBubble,
      iconoirOpenInWindow,
      iconoirHealthShield,
      iconoirNavArrowLeft,
    }),
  ],
  templateUrl: './product-details.component.html',
  styleUrl: './product-details.component.scss',
})
export class ProductDetailsComponent extends Route implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  protected dictionaryService = inject(DictionaryService);
  private reportsService = inject(ReportsService);
  private configService = inject(ConfigService);

  productId = signal<string>('');
  // for loading states
  isDownloadingComments = signal(false);
  isDownloadingSFE = signal(false);

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.productId.set(params['id'] || '');
    });
  }

  goBack(): void {
    this.router.navigate(['/products']);
  }

  downloadCommentsReport(): void {
    const productId = this.productId();
    const from = this.configService.from();
    const to = this.configService.to();

    if (!productId || !from || !to) return;

    this.isDownloadingComments.set(true);
    this.reportsService
      .getProductVisitCommentsReport(productId, from, to)
      .subscribe({
        next: (response: reportResponse) => {
          this.isDownloadingComments.set(false);
          if (response.success && response.data?.reportURL) {
            this.reportsService.downloadReport(response.data.reportURL);
          }
        },
        error: () => {
          this.isDownloadingComments.set(false);
        },
      });
  }

  downloadSFEReport(): void {
    const productId = this.productId();
    const from = this.configService.from();
    const to = this.configService.to();

    if (!productId || !from || !to) return;

    this.isDownloadingSFE.set(true);
    this.reportsService.getProductSFEReport(productId, from, to).subscribe({
      next: (response: reportResponse) => {
        this.isDownloadingSFE.set(false);
        if (response.success && response.data?.reportURL) {
          this.reportsService.downloadReport(response.data.reportURL);
        }
      },
      error: () => {
        this.isDownloadingSFE.set(false);
      },
    });
  }
}
